<template>
  <div>
    <div class="topP">
      <div class="top">
        <div
          class="topSubP"
          ref="topSubP"
        >
          <div class="topSub">
            <div class="topLLP">
              <img
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20260127151631.png"
              />
              <div>微脉水印相机 素材团队管理后台</div>
            </div>
            <div class="topRP">
              <div class="topRP">
                <!-- <div class="topRR2">
                  <img
                    v-if="faceIcon && faceIcon.length"
                    class="header-main-top"
                    :src="faceIcon"
                  />
                  <img
                    v-else
                    class="header-main-top"
                    src="https://imagessl.edujia.com/A-1ed71af7_20230804094317.png"
                  />
                  <div>{{ userName }}</div>
                </div> -->
                <div class="topRBtnP">
                  <div
                    class="oldBtn"
                    @click="go2old"
                  >
                    回旧版
                  </div>
                  <div
                    class="logoutBtn"
                    @click="logout"
                  >
                    退出登录
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contentP">
      <!-- <div class="topBP">
        <div class="topB">
          <div class="topLP">当前团队：</div>
          <div class="topRP">
            <div
              v-if="teamList && teamList.length && teamSelIdx >= 0"
              class="topL"
            >
              <div class="topLR">
                {{ teamList[teamSelIdx].teamName }}
              </div>
              <img
                v-if="teamList[teamSelIdx].roleType == 100"
                class="topLL"
                src="https://imagessl.edujia.com/A-1ed71af7_20230804094647.png"
              />
              <img
                v-else-if="teamList[teamSelIdx].roleType == 90"
                class="topLL"
                src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png"
              />
            </div>
            <div class="topR">
              <div
                class="changeTeamBtn"
                @click="changeTeam"
              >
                切换团队
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="content">
        <div class="contentL">
          <div
            :class="
              tabIndex == 0 ? 'contentLItem contentLItemLight' : 'contentLItem'
            "
            @click="tabClick(0)"
          >
            <img
              v-if="tabIndex == 0"
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20260612165212.png"
            />
            <img
              v-else
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20260612170420.png"
            />
            <div>素材列表</div>
          </div>
          <div
            :class="
              tabIndex == 1 ? 'contentLItem contentLItemLight' : 'contentLItem'
            "
            @click="tabClick(1)"
          >
            <img
              v-if="tabIndex == 1"
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20260612170638.png"
            />
            <img
              v-else
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20260612170651.png"
            />
            <div :style="{ 'margin-top': '-10px' }">定时列表</div>
          </div>
          <div class="contentLUser">
            <img
              v-if="faceIcon && faceIcon.length"
              class="header-main-top"
              :src="faceIcon"
            />
            <img
              v-else
              class="header-main-top"
              src="https://imagessl.edujia.com/A-1ed71af7_20230804094317.png"
            />
            <div>{{ userName }}</div>
          </div>
        </div>
        <div class="contentR">
          <div class="topB">
            <div class="topLP">当前团队：</div>
            <div class="topRP">
              <div
                v-if="teamList && teamList.length && teamSelIdx >= 0"
                class="topL"
              >
                <div class="topLR">
                  {{ teamList[teamSelIdx].teamName }}
                </div>
                <img
                  v-if="teamList[teamSelIdx].roleType == 100"
                  class="topLL"
                  src="https://imagessl.edujia.com/A-1ed71af7_20230804094647.png"
                />
                <img
                  v-else-if="teamList[teamSelIdx].roleType == 90"
                  class="topLL"
                  src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png"
                />
              </div>
              <div class="topR">
                <div
                  class="changeTeamBtn"
                  @click="changeTeam"
                >
                  切换团队
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="tabIndex == 0"
            class="filterBar"
          >
            <div :style="{ display: 'flex' }">
              <div
                v-if="tabIndex == 1"
                class="timeSendLabel"
              >
                定时素材
              </div>
              <el-input
                class="filterInput"
                v-model="keywords"
                placeholder="输入关键词"
              ></el-input>
              <el-select
                class="filterInput"
                v-model="categoryId"
                placeholder="全部分类"
              >
                <el-option
                  v-for="op in categoryList"
                  :key="op.labelid"
                  :label="op.labelName"
                  :value="op.labelid"
                >
                </el-option>
              </el-select>
              <el-select
                class="filterInput"
                v-model="tagId"
                placeholder="选择标签"
              >
                <el-option
                  v-for="op in tagList"
                  :key="op.tagid"
                  :label="op.tagName"
                  :value="op.tagid"
                >
                </el-option>
              </el-select>
              <div
                class="filterBtn"
                @click="searchSucai"
              >
                查找素材
              </div>
            </div>
            <div
              v-if="tabIndex == 0 && !batchClassifyMode"
              class="releaseBtn"
              @click="releaseSucaiClick"
            >
              发布素材
            </div>
            <div
              v-if="tabIndex == 0 && !batchClassifyMode"
              class="batchBtn"
              @click="enterBatchMode"
            >
              批量分类
            </div>
            <div
              v-if="tabIndex == 0 && batchClassifyMode"
              :class="batchSelectedMids.length ? 'releaseBtn' : 'releaseBtn batchCompleteDisabled'"
              @click="completeBatchClassify"
            >
              下一步
            </div>
            <div
              v-if="tabIndex == 0 && batchClassifyMode"
              class="batchExitBtn"
              @click="exitBatchMode"
            >
              退出批量
            </div>
          </div>
          <div :style="{ 'background-color': '#fff' }">
            <div class="listTitleBar">
              <div
                class="listTitleBarItem"
                :style="{ width: '270px' }"
              >
                文案
              </div>
              <div
                class="listTitleBarItem"
                :style="{ width: '317px' }"
              >
                图片视频
              </div>
              <div
                class="listTitleBarItem"
                :style="{ width: '130px', textAlign: 'center' }"
              >
                分类
              </div>
              <div
                class="listTitleBarItem"
                :style="{ width: '120px', textAlign: 'center' }"
              >
                发布时间
              </div>
              <div
                class="listTitleBarItem"
                :style="{ width: '140px', textAlign: 'center' }"
              >
                发布人
              </div>
              <div
                class="listTitleBarItem"
                :style="{ width: '185px', textAlign: 'center' }"
              >
                备注
              </div>
              <div
                class="listTitleBarItem"
                :style="{ width: '178px', textAlign: 'center' }"
              >
                操作
              </div>
            </div>
            <div class="list">
              <div
                v-for="(item, idx) in sucaiList"
                :key="idx"
                class="listContentBar"
                :style="{
                  'background-color': hoverIdx == idx ? '#FAFAFA' : '#fff',
                }"
                @mouseenter="hoverIdx = idx"
                @mouseleave="hoverIdx = -1"
              >
                <div
                  v-if="batchClassifyMode"
                  class="listContentBarItem"
                  :style="{ width: '50px', justifyContent: 'center' }"
                  @click.stop
                >
                  <el-checkbox
                    :value="isMaterialSelected(item)"
                    @change="toggleMaterialSelect(item)"
                  ></el-checkbox>
                </div>
                <div
                  v-if="item.isTop == 1"
                  class="topSucaiIcon"
                >
                  置顶
                </div>
                <div
                  class="listContentBarItem"
                  :style="{
                    width: '238px',
                    padding: '0 16px',
                    display: '-webkit-box',
                    // height: 'calc(100% - 32px)',
                  }"
                  @mouseenter.stop="listItemMouseEnter(idx)"
                >
                  <div
                    class="shadowTipSize"
                    :ref="'shadowTipSize' + idx"
                  >
                    {{ item.detail }}
                  </div>
                  <el-tooltip
                    v-if="item.needTooltip"
                    placement="top"
                    :open-delay="500"
                  >
                    <div slot="content">
                      <div class="tooltipContent">{{ item.detail }}</div>
                    </div>
                    <div>{{ item.detail }}</div>
                  </el-tooltip>
                  <div v-else>{{ item.detail }}</div>
                  <div class="listTitleBarItemBorder"></div>
                </div>
                <div
                  v-if="item.mediaType == 1"
                  class="listContentBarItem"
                  :style="{
                    width: '300px',
                    padding: '0 8px',
                    justifyContent: 'flex-start',
                  }"
                >
                  <div
                    v-for="(img, idx) in item.imageUrls.slice(0, 5)"
                    :key="idx"
                    class="imgContentItem"
                  >
                    <img
                      class="imgContentItemImg"
                      :src="item.domain + img.picUrl"
                      @click.stop="go2Preview(item, idx)"
                    />
                    <div
                      v-if="idx == 4"
                      class="imgMore"
                      @click.stop="go2ImgMore(item)"
                    >
                      <div>
                        <div>
                          共{{
                            item.imageUrls &&
                            item.imageUrls.length <= 9 &&
                            item.imageUrls[0].hiddenCount
                              ? item.imageUrls.length +
                                item.imageUrls[0].hiddenCount
                              : item.imageUrls.length
                          }}张
                        </div>
                        <div>查看全部</div>
                      </div>
                    </div>
                  </div>
                  <div class="listTitleBarItemBorder"></div>
                </div>
                <div
                  v-else-if="item.mediaType == 2"
                  class="listContentBarItem"
                  :style="{
                    width: '300px',
                    padding: '0 8px',
                    justifyContent: 'flex-start',
                  }"
                >
                  <div
                    class="videoContentItem"
                    @click.stop="previewVideo(item)"
                  >
                    <img
                      class="videoContentItemPlayIcon"
                      src="https://imagessl.lingtuo.cn/A-1ed71af7_20260127180929.png"
                    />
                    <img
                      class="videoContentItemImg"
                      :src="
                        $common.getVideoPoster(item.mediaDomain + item.videoKey)
                      "
                    />
                  </div>
                  <div class="listTitleBarItemBorder"></div>
                </div>
                <div
                  v-else-if="item.mediaType == 3"
                  class="listContentBarItem"
                  :style="{
                    width: '300px',
                    padding: '0 8px',
                    justifyContent: 'flex-start',
                  }"
                >
                  <div class="linkContentItem">
                    <img
                      v-if="item.imageUrls.length > 0"
                      class="linkContentItemIcon"
                      :src="item.domain + item.imageUrls[0].picUrl"
                    />
                    <div>
                      <div class="linkContentItemR1">
                        {{ item.articleTitle }}
                      </div>
                      <a
                        class="linkContentItemR2"
                        :href="
                          item.articleUrl.startsWith('http')
                            ? item.articleUrl
                            : 'https://' + item.articleUrl
                        "
                        target="_blank"
                        >{{ item.articleUrl }}</a
                      >
                    </div>
                  </div>
                  <div class="listTitleBarItemBorder"></div>
                </div>
                <div
                  class="listContentBarItem"
                  :style="{
                    width: '114px',
                    padding: '0 8px',
                    flexWrap: 'wrap',
                    overflowY: 'scroll'
                  }"
                >
                  {{
                    item.labelData
                      ? item.labelData.map((item) => item.labelName).join("、")
                      : ""
                  }}
                  <span
                    v-if="
                      item.labelData &&
                      item.labelData.length > 0 &&
                      item.tagData &&
                      item.tagData.length > 0
                    "
                    >-</span
                  >
                  <span v-if="item.tagData && item.tagData.length > 0">
                    {{
                      item.tagData
                        ? item.tagData.map((item) => item.tagName).join(",")
                        : ""
                    }}
                  </span>
                  <div
                    class="listTitleBarItemBorder"
                    :style="{ height: '40px', top: 'calc(50% - 20px)' }"
                  ></div>
                </div>
                <div
                  class="listContentBarItem"
                  :style="{
                    width: '104px',
                    padding: '0 8px',
                    display: 'grid',
                  }"
                >
                  <div>
                    {{ item.createTime ? item.createTime.split(" ")[0] : "" }}
                  </div>
                  <div>
                    {{ item.createTime ? item.createTime.split(" ")[1] : "" }}
                  </div>
                  <div
                    class="listTitleBarItemBorder"
                    :style="{ height: '40px', top: 'calc(50% - 20px)' }"
                  ></div>
                </div>
                <div
                  class="listContentBarItem"
                  :style="{
                    width: '124px',
                    padding: '0 8px',
                    display: 'grid',
                  }"
                >
                  <img
                    class="listContentUserIcon"
                    :src="item.faceIcon"
                  />
                  {{ item.nickname }}
                  <div
                    class="listTitleBarItemBorder"
                    :style="{ height: '40px', top: 'calc(50% - 20px)' }"
                  ></div>
                </div>
                <div
                  class="listContentBarItem"
                  :style="{
                    width: '166px',
                    padding: '8px 8px 8px 12px',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    maxHeight: '85px',
                    overflowY: 'auto',
                    cursor: 'pointer',
                  }"
                  @click.stop="remarkClick(item)"
                >
                  <div
                    v-if="item.remarkData && item.remarkData.length"
                    class="remarkListScroll"
                    style="display: flex; flex-direction: column; gap: 2px"
                  >
                    <div
                      v-for="(rm, i) in item.remarkData"
                      :key="i"
                      style="
                        gap: 4px;
                        font-size: 12px;
                        color: #3c3c3c;
                        line-height: 16px;
                      "
                    >
                      <span
                        style="
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          min-width: 0;
                          max-width: 200px;
                          display: block;
                        "
                        >{{ rm.content || "(空)" }}</span
                      >
                      <img
                        v-if="rm.imageUrl"
                        :src="rm.imageUrl"
                        style="
                          flex-shrink: 0;
                          width: 50px;
                          height: 50px;
                          object-fit: cover;
                          border-radius: 2px;
                        "
                      />
                    </div>
                  </div>

                  <div
                    class="listTitleBarItemBorder"
                    :style="{ height: '40px', top: 'calc(50% - 20px)' }"
                  ></div>
                </div>
                <div
                  class="listContentBarItem"
                  :style="{
                    width: '162px',
                    padding: '0 8px',
                    flexWrap: 'wrap',
                  }"
                  v-if="!batchClassifyMode && teamList[teamSelIdx].roleType != 0"
                >
                  <div
                    class="listContentBarActionItem"
                    @click="editClick(item)"
                  >
                    编辑
                  </div>
                  <div
                    v-if="tabIndex == 0"
                    class="listContentBarActionItem"
                    @click="copyClick(item)"
                  >
                    复用
                  </div>
                  <div
                    v-if="tabIndex == 0"
                    class="listContentBarActionItem listContentBarActionItemRemark"
                    @click="openAddRemark(item)"
                  >
                    备注
                  </div>
                  <div
                    class="listContentBarActionItem listContentBarActionItemDelete"
                    @click="tabIndex == 0 ? deleteClick(item) : delTask(item)"
                  >
                    删除
                  </div>
                </div>
                <div
                  class="listContentBarItem"
                  :style="{
                    width: '152px',
                    padding: '0 8px',
                    flexWrap: 'wrap',
                  }"
                  v-else
                ></div>
                <div
                  v-if="item.isVisible != 1"
                  class="cellCover"
                  @click.stop
                >
                  <div class="background-container">
                    <div class="glass-mask">
                      <div class="glass-mask-main">
                        <img
                          src="https://imagessl.lingtuo.cn/A-1ed71af7_20260303170105.png"
                        />
                        无查看权限
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pageBar">
              <div
                v-if="batchClassifyMode"
                class="batchSelectAllBar"
              >
                <el-checkbox
                  v-model="batchSelectAll"
                  @change="toggleSelectAll"
                >
                  全选
                </el-checkbox>
              </div>
              <div></div>
              <div class="pageBarRight">
              <div
                v-if="page > 1"
                class="pageBtn"
                @click="handlePageChange(false)"
              >
                上一页
              </div>
              <div>
                <input
                  class="pageInput"
                  type="number"
                  v-model="page"
                  @keyup.enter="handlePageEnter"
                />
              </div>
              <div
                class="pageBtn"
                @click="handlePageChange(true)"
              >
                下一页
              </div>
              </div>
              <!-- <el-pagination
              style="display: flex; align-items: center"
              background
              :page-size="pageSize"
              :current-page.sync="page"
              layout=" prev, slot, next"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
              <div>
                <input
                  class="pageInput"
                  type="number"
                  v-model="page"
                />
              </div>
            </el-pagination> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="remarkEditShow"
      class="remarkEditCover"
      @click.self="closeRemarkEdit"
    >
      <div class="remarkEditMain">
        <div class="remarkEditMainT">
          <div class="remarkEditMainTL">编辑备注</div>
          <img
            class="remarkEditMainTR"
            src="https://imagessl.lingtuo.cn/A-1ed71af7_20260128110047.png"
            @click="closeRemarkEdit"
          />
        </div>
        <div
          class="remarkSelectorBar"
          v-if="
            currentRemarkItem &&
            currentRemarkItem.remarkData &&
            currentRemarkItem.remarkData.length > 0 &&
            remarkEditIndex < currentRemarkItem.remarkData.length
          "
        >
          <div class="remarkSelectorNav">
            <span
              class="remarkSelectorArrow"
              :class="{ remarkSelectorArrowDisabled: remarkEditIndex <= 0 }"
              @click="selectRemark(remarkEditIndex - 1)"
              >◀</span
            >
            <span class="remarkSelectorLabel"
              >备注 {{ remarkEditIndex + 1 }}/{{
                currentRemarkItem.remarkData.length
              }}</span
            >
            <span
              class="remarkSelectorArrow"
              :class="{
                remarkSelectorArrowDisabled:
                  remarkEditIndex >= currentRemarkItem.remarkData.length - 1,
              }"
              @click="selectRemark(remarkEditIndex + 1)"
              >▶</span
            >
          </div>
        </div>
        <div class="remarkEditMainB">
          <div class="remarkFormItem">
            <div class="remarkFormItemL">备注内容</div>
            <div class="remarkFormItemR">
              <textarea
                v-model="remarkText"
                class="remarkTextarea"
                placeholder="请输入备注内容"
              ></textarea>
            </div>
          </div>
          <div class="remarkFormItem">
            <div class="remarkFormItemL">备注图片</div>
            <div class="remarkFormItemR">
              <div class="remarkImageGrid">
                <div
                  v-for="(img, idx) in remarkImages"
                  :key="'remarkImg' + idx"
                  class="remarkImageItem"
                >
                  <img
                    :src="img.picUrl || getRemarkImgUrl(img)"
                    class="remarkImagePreview"
                    @click="previewRemarkImage(img)"
                  />
                  <div
                    class="remarkImageRemove"
                    @click="removeRemarkImage(idx)"
                  >
                    ×
                  </div>
                </div>
                <div
                  v-if="remarkImages.length < 1"
                  class="remarkImageAdd"
                  @click="triggerRemarkImageInput"
                >
                  <img
                    src="https://imagessl.lingtuo.cn/A-1ed71af7_20260129142041.png"
                  />
                </div>
              </div>
              <input
                ref="remarkImageInput"
                type="file"
                accept="image/*"
                class="remarkHiddenInput"
                @change="handleRemarkImageSelect"
              />
            </div>
          </div>
        </div>
        <div class="remarkEditMainBottomBar">
          <div
            v-if="
              currentRemarkItem &&
              currentRemarkItem.remarkData &&
              currentRemarkItem.remarkData.length > 0 &&
              remarkEditIndex < currentRemarkItem.remarkData.length
            "
            class="remarkDeleteBtn"
            @click="deleteRemark"
          >
            删除备注
          </div>
          <div
            class="remarkCancelBtn"
            @click="closeRemarkEdit"
          >
            取消
          </div>
          <div
            class="remarkSaveBtn"
            @click="saveRemark"
          >
            保存
          </div>
        </div>
      </div>
    </div>
    <!-- 批量分类弹窗 -->
    <div
      v-if="batchClassifyShow"
      class="batchClassifyCover"
      @click.self="closeBatchClassify"
    >
      <div class="batchClassifyMain">
        <div class="batchClassifyMainT">
          <div class="batchClassifyMainTL">
            <span v-if="batchSelCategoryList.length || batchSelTagList.length">已选：{{ batchSelectCategoryTagLabel }}</span>
            <span v-else>未分类</span>
          </div>
          <img
            class="batchClassifyMainTR"
            src="https://imagessl.lingtuo.cn/A-1ed71af7_20260128110047.png"
            @click="closeBatchClassify"
          />
        </div>
        <div class="batchClassifyMainB">
          <div class="batchClassifyTips">
            已选 {{ batchSelectedMids.length }} 个素材
          </div>
          <div class="batchDialogSection">
            <div class="batchDialogSectionT">选择分类</div>
            <div class="batchDialogSectionB">
              <div
                v-for="category in batchCategoryList"
                :key="category.labelid"
                :class="
                  batchSelCategoryList.some(
                    (c) => c.labelid === category.labelid,
                  )
                    ? 'batchChip batchChipSel'
                    : 'batchChip'
                "
                @click="batchSelectCategory(category)"
              >
                {{ category.labelName }}
              </div>
            </div>
          </div>
          <div
            v-if="batchTagList.length"
            class="batchDialogSection"
          >
            <div class="batchDialogSectionT">选择标签</div>
            <div class="batchDialogSectionB">
              <div
                v-for="tag in batchTagList"
                :key="tag.tagid"
                :class="
                  batchSelTagList.some((t) => t.tagid === tag.tagid)
                    ? 'batchChip batchChipSel'
                    : 'batchChip'
                "
                @click="batchSelectTag(tag)"
              >
                {{ tag.tagName }}
              </div>
            </div>
          </div>
        </div>
        <div class="batchClassifyMainBottomBar">
          <div
            class="batchClassifyCancelBtn"
            @click="closeBatchClassify"
          >
            取消
          </div>
          <div
            class="batchClassifyConfirmBtn"
            @click="confirmBatchClassify"
          >
            确定
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="teamListShow"
      class="teamListMask"
      @click="hideTeamList"
    ></div>
    <div
      v-if="teamListShow"
      class="teamListCover"
    >
      <!-- <div
        class="listAdd listAdd2"
        @click="createTeam"
      >
        <img
          src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812095807.png"
        />新建团队
      </div> -->
      <div class="listAdd listAdd2"></div>
      <div class="teamListP">
        <div class="teamList">
          <div
            v-for="(item, idx) in teamList"
            :key="'teamListItem' + idx"
            :class="
              idx == teamSelIdx
                ? 'teamListItemSel teamListItem'
                : 'teamListItem'
            "
            @click="teamItemClick(idx)"
          >
            <img
              v-if="item.roleType == 90"
              src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png"
            />
            <img
              v-else-if="item.roleType == 100"
              src="https://imagessl.edujia.com/A-1ed71af7_20231025160621.png"
            />
            <div>{{ item.teamName }}</div>
          </div>
        </div>
      </div>
      <img
        src="https://imagessl.lingtuo.cn/A-1ed71af7_20250919100121.png"
        class="themeListCloseBtn"
        @click="hideTeamList"
      />
    </div>
    <transition name="fade">
      <EditSucai
        v-if="editSucaiShow"
        ref="editSucai"
        @close="editClose"
      />
    </transition>
    <transition name="fade">
      <ReuseSucai
        v-if="reuseSucaiShow"
        ref="reuseSucai"
        @close="reuseSucaiShow = false"
      />
    </transition>
    <!-- 新增：视频预览遮罩层 -->
    <div
      v-if="videoPreviewShow"
      class="videoPreviewMask"
      @click="closeVideoPreview"
    >
      <div
        class="videoPreviewContent"
        @click.stop
      >
        <video
          :src="currentVideoUrl"
          controls
          autoplay
          class="videoPlayer"
        ></video>
        <div
          class="videoCloseBtn"
          @click="closeVideoPreview"
        >
          ×
        </div>
      </div>
    </div>
    <!-- 备注图片预览 -->
    <div
      v-if="remarkImagePreviewShow"
      class="videoPreviewMask"
      @click="closeRemarkImagePreview"
    >
      <div
        class="videoPreviewContent"
        @click.stop
        style="background: transparent"
      >
        <img
          :src="remarkImagePreviewUrl"
          style="
            max-width: 90vw;
            max-height: 90vh;
            object-fit: contain;
            border-radius: 4px;
          "
        />
        <div
          class="videoCloseBtn"
          @click="closeRemarkImagePreview"
        >
          ×
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import EditSucai from "@/components/EditSucai.vue";
import ReuseSucai from "@/components/ReuseSucai.vue";
import Vue from "vue";
import {
  Dialog,
  Button,
  Loading,
  Radio,
  RadioGroup,
  Switch,
  Popover,
  Select,
  Option,
  Input,
  Tooltip,
  Checkbox,
} from "element-ui";
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Loading);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Switch);
Vue.use(Popover);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Tooltip);
Vue.use(Checkbox);

export default {
  name: "Home",
  data() {
    return {
      pageWidth:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
      pageHeight:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight,
      tabIndex: 0,
      teamSelIdx: -1,
      teamListLoadend: false,
      teamList: [],
      teamListShow: false,
      loading: false,
      hoverIdx: -1,
      categoryList: [],
      keywords: "",
      editSucaiShow: false,
      reuseSucaiShow: false,
      remarkEditShow: false,
      currentRemarkItem: null,
      remarkEditIndex: 0,
      remarkText: "",
      remarkImages: [],
      page: 1,
      pageSize: 10,
      tagList: [],
      categoryId: "",
      tagId: "",
      sucaiList: [],
      videoPreviewShow: false,
      currentVideoUrl: "",
      remarkImagePreviewShow: false,
      remarkImagePreviewUrl: "",
      // 批量分类
      batchClassifyMode: false,
      batchSelectAll: false,
      batchSelectedMids: [], // 已选素材信息
      // 批量分类弹窗
      batchClassifyShow: false,
      batchSelCategoryList: [],
      batchSelTagList: [],
      batchAllTagList: [],
      batchTagList: [],
      batchCategoryList: [],
    };
  },
  computed: {
    batchSelectCategoryTagLabel() {
      let categoryLabel = this.batchSelCategoryList
        .map((i) => i.labelName)
        .join("、");
      if (this.batchSelTagList.length) {
        if (categoryLabel) {
          categoryLabel += "-";
        }
        categoryLabel += this.batchSelTagList
          .map((i) => i.tagName)
          .join("、");
      }
      return categoryLabel;
    },
  },
  watch: {
    teamSelIdx: {
      async handler(newVal, oldVal) {
        if (newVal != oldVal && newVal >= 0) {
          this.keywords = "";
          this.page = 1;
          this.sucaiList = [];
          this.categoryId = "";
          this.tagId = "";
          if (this.tabIndex == 0) {
            await this.queryCategoryList();
            await this.queryTagList();
          }
          await this.querySucaiList();
        }
      },
      immediate: true,
    },
    tabIndex: {
      async handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.keywords = "";
          this.page = 1;
          this.sucaiList = [];
          this.categoryId = "";
          this.tagId = "";
          if (this.teamSelIdx == -1) {
            this.queryTeamList();
          } else {
            await this.querySucaiList();
          }
        }
      },
      immediate: true,
    },
    categoryId: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          if (newVal != "") {
            this.tagId = "";
          }
          if (this.teamSelIdx != -1) {
            this.page = 1;
            this.sucaiList = [];
            this.queryTagList(newVal);
            this.querySucaiList();
          }
        }
      },
      immediate: true,
    },
    tagId: {
      handler(newVal, oldVal) {
        if (newVal != "") {
          this.categoryId = "";
        }
        if (newVal != oldVal) {
          if (this.teamSelIdx != -1) {
            this.page = 1;
            this.sucaiList = [];
            this.querySucaiList();
          }
        }
      },
      immediate: true,
    },
  },
  components: { EditSucai, ReuseSucai },
  methods: {
    tabClick(index) {
      this.tabIndex = index;
      localStorage.setItem("tabIndex", index);
    },
    go2old() {
      window.location.href = "https://service.lingtuo.cn/web/index.html";
    },
    listItemMouseEnter(idx) {
      let item = this.sucaiList[idx];
      const dom = this.$refs["shadowTipSize" + idx][0];
      // 核心判断：内容总高度 > 可视高度
      if (dom.scrollHeight > dom.clientHeight) {
        item.needTooltip = true;
        this.sucaiList.splice(idx, 1, item);
      }
    },
    // 新增：视频预览方法
    previewVideo(item) {
      this.currentVideoUrl = item.mediaDomain + item.videoKey;
      this.videoPreviewShow = true;
    },
    // 新增：关闭视频预览
    previewRemarkImage(img) {
      this.remarkImagePreviewUrl = img.picUrl || this.getRemarkImgUrl(img);
      this.remarkImagePreviewShow = true;
    },
    closeRemarkImagePreview() {
      this.remarkImagePreviewShow = false;
      this.remarkImagePreviewUrl = "";
    },
    closeVideoPreview() {
      this.videoPreviewShow = false;
      this.currentVideoUrl = "";
    },
    handlePageEnter() {
      this.querySucaiList();
    },
    handlePageChange(isNext) {
      if (isNext && this.sucaiList.length == this.pageSize) {
        ++this.page;
        this.querySucaiList();
      } else if (this.page > 1 && !isNext) {
        --this.page;
        this.querySucaiList();
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.querySucaiList();
    },
    editClose(needRefresh) {
      this.editSucaiShow = false;
      if (needRefresh) {
        this.querySucaiList();
      }
    },
    searchSucai() {
      this.page = 1;
      this.querySucaiList();
    },
    teamItemClick(idx) {
      this.teamSelIdx = idx;
      this.teamListShow = false;
      localStorage.setItem("currentTeamIndex", idx);
    },
    async go2Preview(sucaiItem, idx) {
      let _this = this;
      console.log("go2Preview:", sucaiItem);
      let imgList = sucaiItem.imageUrls;

      if (imgList.length && imgList.length <= 9 && imgList[0].hiddenCount) {
        let moreList = await this.getSucaiImgMore(sucaiItem);
        if (moreList.length) {
          imgList = moreList;
          sucaiItem.imageUrls = imgList;
        }
      }

      this.$viewerApi({
        images: imgList.map((item) => sucaiItem.domain + item.picUrl),
        options: {
          // 这里可以配置 viewer.js 的原生选项
          toolbar: true,
          navbar: true,
          images: this.sourceImageObjects,
          initialViewIndex: idx,
        },
      });
    },
    async getSucaiImgMore(sucaiItem) {
      return new Promise(async (resolve, reject) => {
        let resp = await this.$http.querySucaiImageListMore({
          teamNO: this.teamList[this.teamSelIdx].teamNO,
          mid: sucaiItem.id,
        });
        console.log("querySucaiImageListMore resp:", resp);
        if (resp.code == 200) {
          resolve(resp.data.array);
        }
      });
    },
    //查看全部图片
    async go2ImgMore(sucaiItem) {
      let imgList = sucaiItem.imageUrls;
      if (imgList.length && imgList.length <= 9 && imgList[0].hiddenCount) {
        let moreList = await this.getSucaiImgMore(sucaiItem);
        if (moreList.length) {
          imgList = moreList;
          sucaiItem.imageUrls = imgList;
        }
      }
      this.$viewerApi({
        images: imgList.map((item) => sucaiItem.domain + item.picUrl),
        options: {
          // 这里可以配置 viewer.js 的原生选项
          toolbar: true,
          navbar: true,
          images: this.sourceImageObjects,
        },
      });
    },
    logout() {
      localStorage.clear();
      setTimeout(() => {
        window.location.reload();
      }, 10);
      this.$router.replace({ path: "/wlogin" });
    },
    releaseSucaiClick() {
      let team = this.teamList[this.teamSelIdx];
      if (!team.roleType) {
        this.$message({
          type: "warning",
          message: "无发布权限",
        });
        return;
      }

      this.editSucaiShow = true;
      setTimeout(() => {
        this.$refs.editSucai.setSucai({
          team: team,
          sucai: null,
          tagList: this.tagList,
          categoryList: this.categoryList,
        });
      }, 0);
    },
    //备注
    remarkClick(item) {
      console.log("remarkClick:", item);
      this.currentRemarkItem = item;
      this.remarkEditIndex = 0;
      this.loadRemarkAtIndex(0);
      this.remarkEditShow = true;
    },
    loadRemarkAtIndex(index) {
      const rm =
        this.currentRemarkItem.remarkData &&
        this.currentRemarkItem.remarkData[index];
      if (rm) {
        this.remarkText = rm.content || "";
        this.remarkImages = rm.imageUrl ? [{ picUrl: rm.imageUrl }] : [];
      } else {
        this.remarkText = "";
        this.remarkImages = [];
      }
    },
    selectRemark(index) {
      if (!this.currentRemarkItem || !this.currentRemarkItem.remarkData) return;
      if (index < 0 || index >= this.currentRemarkItem.remarkData.length)
        return;
      this.remarkEditIndex = index;
      this.loadRemarkAtIndex(index);
    },
    openAddRemark(item) {
      this.currentRemarkItem = item;
      if (!item.remarkData) {
        this.$set(item, "remarkData", []);
      }
      this.remarkEditIndex = item.remarkData.length;
      this.remarkText = "";
      this.remarkImages = [];
      this.remarkEditShow = true;
    },
    addNewRemark() {
      if (!this.currentRemarkItem) return;
      if (!this.currentRemarkItem.remarkData) {
        this.$set(this.currentRemarkItem, "remarkData", []);
      }
      this.remarkEditIndex = this.currentRemarkItem.remarkData.length;
      this.remarkText = "";
      this.remarkImages = [];
    },
    closeRemarkEdit() {
      this.remarkEditShow = false;
      this.currentRemarkItem = null;
      this.remarkText = "";
      this.remarkImages = [];
    },
    triggerRemarkImageInput() {
      this.$refs.remarkImageInput.click();
    },
    handleRemarkImageSelect(e) {
      const files = Array.from(e.target.files);
      if (files.length === 0) return;
      // Only allow one image
      this.remarkImages = [{ file: files[0], picUrl: null }];
      // Reset input so same file can be reselected
      e.target.value = "";
    },
    getRemarkImgUrl(img) {
      if (img.file) {
        return URL.createObjectURL(img.file);
      }
      return "";
    },
    removeRemarkImage(idx) {
      const img = this.remarkImages[idx];
      if (img.blobUrl) {
        URL.revokeObjectURL(img.blobUrl);
      }
      this.remarkImages.splice(idx, 1);
    },
    async saveRemark() {
      if (!this.currentRemarkItem) return;

      // Upload images first
      let uploadedUrls = [];
      const needUpload = this.remarkImages.filter((img) => img.file);
      if (needUpload.length > 0) {
        try {
          // Build mediaArr for upload
          const mediaArr = needUpload.map((img, idx) => ({
            seq: idx,
            file: img.file,
            type: "img",
            waitUpload: true,
          }));
          const cosService = await import("@/service/cosService");
          const resultArr = await cosService.default.uploadFileArr(
            mediaArr,
            1,
            this.teamList[this.teamSelIdx].teamNO,
            1,
          );
          uploadedUrls = resultArr.map((r) => r.url);
        } catch (err) {
          console.error("Upload remark images failed:", err);
          this.$message({ type: "error", message: "图片上传失败" });
          return;
        }
      }

      // Merge already-uploaded URLs with new uploads
      let uploadIdx = 0;
      const finalImages = this.remarkImages.map((img) => {
        if (img.file) {
          return uploadedUrls[uploadIdx++];
        }
        return img.picUrl;
      });

      const remarkData = {
        text: this.remarkText,
        images: finalImages,
      };

      // Determine add vs update: editing existing index → update, else → add
      const isUpdate =
        this.currentRemarkItem.remarkData &&
        this.remarkEditIndex < this.currentRemarkItem.remarkData.length;

      const apiParams = {
        teamNO: this.currentRemarkItem.teamNO,
        mid: this.currentRemarkItem.id,
        remark: remarkData.text,
        imageUrl: remarkData.images[0] || "",
      };

      let resp;
      if (isUpdate) {
        apiParams.indexNO = this.remarkEditIndex;
        resp = await this.$http.updateSucaiRemark(apiParams);
      } else {
        resp = await this.$http.addSucaiRemark(apiParams);
      }

      if (resp.code == 200) {
        // Update frontend display model
        this.$set(this.currentRemarkItem, "remark", remarkData);
        // Update raw backend model
        const newRemarkEntry = {
          content: remarkData.text,
          imageUrl: remarkData.images[0] || "",
          time: 0,
        };
        if (
          isUpdate &&
          this.currentRemarkItem.remarkData &&
          this.currentRemarkItem.remarkData[this.remarkEditIndex]
        ) {
          this.$set(
            this.currentRemarkItem.remarkData,
            this.remarkEditIndex,
            Object.assign(
              this.currentRemarkItem.remarkData[this.remarkEditIndex],
              newRemarkEntry,
            ),
          );
        } else {
          if (!this.currentRemarkItem.remarkData) {
            this.$set(this.currentRemarkItem, "remarkData", []);
          }
          this.currentRemarkItem.remarkData.push(newRemarkEntry);
        }
        this.$message({ type: "success", message: "备注保存成功" });
        this.closeRemarkEdit();
      }
    },
    async deleteRemark() {
      if (!this.currentRemarkItem) return;

      try {
        await this.$confirm("确定删除这条备注?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch {
        return;
      }

      const resp = await this.$http.delSucaiRemark({
        teamNO: this.currentRemarkItem.teamNO,
        mid: this.currentRemarkItem.id,
        indexNO: this.remarkEditIndex,
      });

      if (resp.code == 200) {
        this.$set(this.currentRemarkItem, "remark", null);
        if (this.currentRemarkItem.remarkData) {
          this.currentRemarkItem.remarkData.splice(this.remarkEditIndex, 1);
          // If other remarks remain, show the first one
          if (this.currentRemarkItem.remarkData.length > 0) {
            const first = this.currentRemarkItem.remarkData[0];
            this.$set(this.currentRemarkItem, "remark", {
              text: first.content || "",
              images: first.imageUrl ? [first.imageUrl] : [],
            });
          }
        }
        if (this.remarkEditIndex > 0) {
          this.remarkEditIndex = this.remarkEditIndex - 1;
          this.loadRemarkAtIndex(this.remarkEditIndex);
        } else if (this.currentRemarkItem.remarkData.length === 0) {
          this.remarkEditIndex = 0;
          this.remarkText = "";
          this.remarkImages = [];
        }
        this.$message({ type: "success", message: "备注已删除" });
      }
    },
    //编辑
    editClick(item) {
      console.log("editClick:", item);
      this.editSucaiShow = true;
      setTimeout(() => {
        this.$refs.editSucai.setSucai({
          team: this.teamList[this.teamSelIdx],
          sucai: item,
          isTask: this.tabIndex == 1,
        });
      }, 0);
    },
    //复用
    copyClick(item) {
      console.log("copyClick:", item);
      this.reuseSucaiShow = true;
      setTimeout(() => {
        this.$refs.reuseSucai.setSucai({
          teamList: this.teamList,
          sucai: item,
        });
      }, 0);
    },
    //刷新
    refreshClick(item) {
      console.log("refreshClick:", item);
    },
    //删除定时任务
    delTask(item) {
      console.log("delTask:", item);
      this.$confirm("确定删除这条定时任务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let resp = await this.$http.delTask({
            id: item.id,
            teamNo: item.teamNO,
          });

          if (resp.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.querySucaiList();
          }
        })
        .catch(() => {});
    },
    //删除
    deleteClick(item) {
      console.log("deleteClick:", item);
      this.$confirm("确定删除这条素材?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let resp = await this.$http.delSucai({
            id: item.id,
            teamNo: item.teamNO,
          });

          if (resp.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.querySucaiList();
          }
        })
        .catch(() => {});
    },
    createTeam() {
      this.$confirm(
        '<div><input id="confirmInput" placeholder="请输入团队名称" /><div id="confirmSwitch">成员加入审核<img id="confirmSwitchOpen" src="https://imagessl.lingtuo.cn/A-1ed71af7_20250826142740.png" /><img id="confirmSwitchClose" src="https://imagessl.lingtuo.cn/A-1ed71af7_20250826150435.png" /></div></div>',
        "创建团队",
        {
          confirmButtonText: "保存",
          cancelButtonText: "取消",
          inputPattern: /^.+$/,
          inputErrorMessage: "团队名称不能为空",
          dangerouslyUseHTMLString: true,
        },
      ).then(async (res) => {
        if (res) {
          let teamName = document.getElementById("confirmInput").value;
          console.log("teamName:", teamName);

          let params = {
            name: teamName,
            isCheck: this.joinNeedCheck ? 1 : 0,
          };
          let resp = await this.$http.huashuTeamCreate(params);
          if (resp.code == 200) {
            document.getElementById("confirmInput").value = "";
            this.$message({
              message: "创建成功",
              type: "success",
            });
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        }
      });
      // setTimeout(() => {
      //   document
      //     .getElementById("confirmSwitch")
      //     .addEventListener("click", this.confirmSwitchClick);
      // }, 1);
    },
    changeTeam() {
      this.teamListShow = true;
    },
    hideTeamList() {
      this.teamListShow = false;
    },
    //查询分类列表
    queryCategoryList() {
      return new Promise(async (resolve, reject) => {
        if (!this.teamList.length) {
          resolve();
          return;
        }
        let params = {
          teamNo: this.teamList[this.teamSelIdx].teamNO,
        };
        let resp = await this.$http.queryCategoryList(params);
        if (resp.code == 200) {
          let allItme = {
            labelid: "",
            labelName: "全部分类",
          };
          this.categoryList = [allItme, ...resp.data.array];
        }
        resolve();
      });
    },
    //查询团队列表
    queryTeamList() {
      return new Promise(async (resolve, reject) => {
        let params = {};
        let resp = await this.$http.queryTeamList(params);
        if (resp.code == 200) {
          this.teamList = resp.data.array;
          if (localStorage.getItem("currentTeamIndex")) {
            this.teamSelIdx = localStorage.getItem("currentTeamIndex");
          } else {
            this.teamSelIdx = 0;
          }
        }
        resolve();
      });
    },
    //查询标签列表
    queryTagList(categoryId) {
      return new Promise(async (resolve, reject) => {
        if (!this.teamList.length) {
          resolve();
          return;
        }
        let params = {
          teamNo: this.teamList[this.teamSelIdx].teamNO,
        };
        if (categoryId) {
          params.labelId = categoryId;
        }
        let resp = await this.$http.queryTagList(params);
        if (resp.code == 200) {
          let allItem = {
            tagid: "",
            tagName: "全部标签",
          };
          this.tagList = [allItem, ...resp.data.array];
        }
        resolve();
      });
    },
    //查询话术文件标题
    async querySucaiList() {
      return new Promise(async (resolve, reject) => {
        if (!this.teamList.length) {
          resolve([]);
          return;
        }
        let params = {
          page: Number(this.page),
          pageSize: this.pageSize,
          teamNo: this.teamList[this.teamSelIdx].teamNO,
        };

        let resp;
        params.keyword = this.keywords;
        if (this.categoryId) {
          params.labelId = this.categoryId;
        } else {
          params.labelId = 0;
        }
        if (this.tagId) {
          params.tagId = this.tagId;
        }
        if (this.tabIndex == 0) {
          resp = await this.$http.querySucaiList(params);
        } else {
          resp = await this.$http.queryTaskList(params);
        }

        if (resp.code == 200) {
          let data = resp.data;
          if (this.tabIndex == 0) {
            data = JSON.parse(
              this.$common.decrypt(
                resp.data,
                localStorage.getItem("edujia:group:web:key"),
              ),
            );
          }

          console.log("querySucaiList res:", data);
          this.sucaiList = data.array.map((item) => {
            if (item.imageUrls.length && typeof item.imageUrls == "string") {
              item.imageUrls = JSON.parse(item.imageUrls);
            }
            if (typeof item.labelData == "string" && item.labelData.length) {
              item.labelData = JSON.parse(item.labelData);
            }

            if (typeof item.tagData == "string" && item.tagData.length) {
              item.tagData = JSON.parse(item.tagData);
            }
            // Normalize remarkData (backend array) → item.remark (frontend object)
            if (item.remarkData) {
              if (typeof item.remarkData === "string") {
                try {
                  item.remarkData = JSON.parse(item.remarkData);
                } catch (e) {}
              }
              if (
                Array.isArray(item.remarkData) &&
                item.remarkData.length > 0
              ) {
                const first = item.remarkData[0];
                item.remark = {
                  text: first.content || "",
                  images: first.imageUrl ? [first.imageUrl] : [],
                };
              }
            }
            return item;
          });
          resolve();
        } else if (resp.code == 1) {
          this.$confirm(resp.message || "操作异常", "认证提示", {
            confirmButtonText: "切换团队",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.teamListShow = true;
            })
            .catch(() => {});
          resolve([]);
        } else {
          resolve([]);
        }
      });
    },
    // ========== 批量分类 ==========
    enterBatchMode() {
      this.batchClassifyMode = true;
      this.batchSelectedMids = [];
    },
    exitBatchMode() {
      this.batchClassifyMode = false;
      this.batchSelectedMids = [];
      this.closeBatchClassify();
    },
    toggleSelectAll(checked) {
      if (checked) {
        this.batchSelectedMids = this.sucaiList.map((item) => ({
          id: item.id,
          orderTop: item.createTimestamp || Date.now(),
        }));
      } else {
        this.batchSelectedMids = [];
      }
    },
    toggleMaterialSelect(item) {
      const idx = this.batchSelectedMids.findIndex((m) => m.id === item.id);
      if (idx >= 0) {
        this.batchSelectedMids.splice(idx, 1);
      } else {
        this.batchSelectedMids.push({
          id: item.id,
          orderTop: item.createTimestamp || Date.now(),
        });
      }
    },
    isMaterialSelected(item) {
      return this.batchSelectedMids.some((m) => m.id === item.id);
    },
    completeBatchClassify() {
      if (this.batchSelectedMids.length === 0) {
        this.$message({ type: "warning", message: "请先选择要分类的素材" });
        return;
      }
      // 过滤掉"全部"占位项
      this.batchCategoryList = this.categoryList.filter(
        (item) => item.labelid !== "",
      );
      this.batchTagList = this.tagList.filter((item) => item.tagid !== "");
      this.batchSelCategoryList = [];
      this.batchSelTagList = [];
      this.batchClassifyShow = true;
    },
    batchSelectCategory(item) {
      const idx = this.batchSelCategoryList.findIndex(
        (c) => c.labelid === item.labelid,
      );
      if (idx >= 0) {
        // 取消选中
        this.batchSelCategoryList = [];
        this.batchTagList = this.batchAllTagList.length
          ? this.batchAllTagList
          : this.tagList.filter((t) => t.tagid !== "");
      } else {
        // 单选：替换为当前项
        this.batchSelCategoryList = [item];
        this.batchSelTagList = [];
        this.batchQueryTagList(item.labelid);
      }
    },
    batchSelectTag(item) {
      const idx = this.batchSelTagList.findIndex(
        (t) => t.tagid === item.tagid,
      );
      if (idx >= 0) {
        this.batchSelTagList.splice(idx, 1);
      } else {
        this.batchSelTagList.push(item);
      }
    },
    async batchQueryTagList(categoryId) {
      if (!this.teamList.length) return;
      const params = {
        teamNo: this.teamList[this.teamSelIdx].teamNO,
      };
      if (categoryId) {
        params.labelId = categoryId;
      }
      const resp = await this.$http.queryTagList(params);
      if (resp.code == 200) {
        this.batchTagList = [...resp.data.array];
        // 缓存全部标签列表
        if (!categoryId && !this.batchAllTagList.length) {
          this.batchAllTagList = [...resp.data.array];
        }
      }
    },
    closeBatchClassify() {
      this.batchClassifyShow = false;
      this.batchSelCategoryList = [];
      this.batchSelTagList = [];
    },
    async confirmBatchClassify() {
      const params = {
        teamNO: this.teamList[this.teamSelIdx].teamNO,
        materialArray: this.batchSelectedMids.map((item) => ({
          mid: item.id,
          orderTop: item.orderTop || Date.now(),
        })),
      };

      if (this.batchSelCategoryList.length) {
        params.addLabelArray = this.batchSelCategoryList.map((item) => ({
          labelid: item.labelid,
          labelName: item.labelName,
        }));
      }

      if (this.batchSelTagList.length) {
        params.tagArray = this.batchSelTagList.map((item) => ({
          tagid: item.tagid,
          tagName: item.tagName,
        }));
      }

      const resp = await this.$http.batchBindCategoryTag(params);
      if (resp.code == 200) {
        this.$message({ type: "success", message: "批量分类成功" });
        this.closeBatchClassify();
        this.exitBatchMode();
        this.querySucaiList();
      }
    },
    // ========== 批量分类结束 ==========
  },
  async created() {
    window.addEventListener("resize", () => {
      this.pageWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      this.pageHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
    });
    this.faceIcon = localStorage.getItem("edujia:group:web:faceIcon");
    this.userName = localStorage.getItem("edujia:group:web:userName");
    if (localStorage.getItem("tabIndex")) {
      this.tabIndex = parseInt(localStorage.getItem("tabIndex"));
    }
    if (localStorage.getItem("edujia:group:web:token")) {
      this.$store.commit(
        "modifyToken",
        localStorage.getItem("edujia:group:web:token"),
      );
    }
  },
  mounted() {},
  activated() {},
};
</script>

<style>
html {
  background-color: #f5f6f6;
}

.viewer-container{
  z-index: 9999999!important;
}

body {
  width: 1440px;
  margin: auto;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}

.el-pagination button,
.el-pagination span:not([class*="suffix"]) {
  height: 40px;
  width: 40px;
}

.el-dialog__body {
  padding: 10px 20px;
}

/* 隐藏垂直滚动条 */
::-webkit-scrollbar {
  width: 10px;
}

/* 隐藏水平滚动条 */
::-webkit-scrollbar {
  height: 0;
}

.el-message-box {
  display: inline-block;
  width: 80%;
  min-width: 200px;
  /* max-width: 300px; */
  max-width: 580px;
  padding-bottom: 10px;
  vertical-align: middle;
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

#confirmInput {
  width: 500px;
  height: 24px;
  background-color: #f5f6f6;
  border: none;
  border-radius: 6px;
  padding: 23px 16px;
  font-size: 18px;
}

#confirmSwitch {
  display: flex;
  align-items: center;
  margin-top: 30px;
}

#confirmSwitch img {
  width: 50px;
  height: 25px;
  margin-left: 20px;
}

#confirmSwitchClose {
  display: none;
}
</style>

<style scoped>
.list {
  width: 100%;
  height: calc(100vh - 247px);
  overflow: scroll;
  background-color: #fff;
}

.contentP {
  /* min-width: 1500px; */
  margin-top: 47px;
}

.content {
  display: flex;
  /* height: calc(100vh - 144px); */
  height: calc(100vh - 47px);
}

.contentL {
  width: 100px;
  height: 100%;
  border-right: 1px solid #eeeeee;
  background-color: #051235;
  position: relative;
}

.contentLUser {
  position: absolute;
  bottom: 60px;
  width: 100%;
  color: #fff;
  text-align: center;
}

.contentR {
  /* width: calc(100% - 144px); */
  width: 1340px;
  height: 100%;
  /* background-color: #fff; */
  /* border-left: 20px solid #f0f0f0; */
}

.topP {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}

.top {
  box-shadow: 0 2px 4px 0 #e5e5e58a;
  width: 100%;
  min-width: 200px;
  height: 47px;
  background-color: #fff;
}

.topBP {
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
}

.topB {
  width: 100%;
  padding: 0 24px;
  height: 50px;
  background-color: #f5f6f6;
  display: flex;
  align-items: center;
}

.topSubP {
  width: 100%;
  height: 100%;
  /* overflow-x: scroll; */
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.topSub {
  display: flex;
  justify-content: space-between;
  width: 95%;
}

.topLP {
  font-size: 20px;
  color: #3c3c3c;
  font-weight: 500;
}

.topLLP {
  margin-left: 16px;
  display: flex;
  align-items: center;
  min-width: 120px;
}

.topLLP img {
  width: 48px;
  height: 48px;
}

.topLLP div {
  font-size: 24px;
  color: #3c3c3c;
  margin-left: 16px;
  font-weight: 600;
}

.topL {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.topLL {
  width: 20px;
  height: 20px;
  margin-left: 8px;
}

.topLR {
  font-size: 22px;
  font-weight: 600;
  color: #3c3c3c;
  margin-left: 8px;
  max-width: 150px;
  height: 32px;
  line-height: 32px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.topRP {
  display: flex;
  align-items: center;
  min-width: 170px;
}

.topRR2 {
  display: flex;
  align-items: center;
  font-size: 20px;
}

.topRR2 img {
}

.changeTeamBtn {
  width: 80px;
  height: 32px;
  background-color: #000000;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin-left: 16px;
}

.topR {
  display: flex;
  align-items: center;
  /*    margin-right: 16px;*/
}

.teamListMask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.teamListCover {
  position: absolute;
  top: 80px;
  left: 50%;
  margin-left: -604px;
  width: 1208px;
  background-color: #fff;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 8px 0 #e5e5e580;
  z-index: 10000;
  padding-bottom: 24px;
}

.teamListP {
  display: flex;
  justify-content: center;
}

.teamList {
  width: 89.74%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin-top: 10px;
}

.themeListCloseBtn {
  position: absolute;
  top: 22px;
  right: 15px;
  width: 20px;
  height: 20px;
}

.teamListItem {
  width: 18%;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  background-color: #f5f6f6;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #3c3c3c;
  font-size: 14px;
  flex-basis: calc(18% - 16px);
  /* 让每个子元素等分，这里假设有3个子元素，减去10px的间隔 */
  margin: 10px;
  /* 添加间隔 */
  box-sizing: border-box;
  position: relative;
}

.teamListItem img {
  position: absolute;
  left: 0;
  top: 0;
  width: 16px;
  height: 16px;
}

.teamListItem div {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;
  overflow: hidden;
  text-align: center;
}

.teamListItemSel {
  border-color: #fb5d5c;
  background-color: #fff6f6;
  color: #fb5d5c;
}

.listAdd2 {
  margin-left: 27px;
  margin-top: 23px;
}

.listAdd {
  display: flex;
  align-items: center;
  color: #4a90e2;
  font-size: 18px;
}

.listAdd img {
  width: 19px;
  height: 19px;
  margin-right: 8.5px;
}

.contentLItem {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  color: #a0a0a0;
  border-right: none;
  border-top: none;
  text-align: center;
  margin-top: 50px;
}

.contentLItem img {
  width: 60px;
  height: 60px;
  margin: auto;
  display: block;
  margin-bottom: 10px;
}

.contentLItemLight {
  color: #fff;
}

.filterBar {
  margin-left: 24px;
  display: flex;
  align-items: center;
  height: 60px;
  /* justify-content: space-between; */
}

.filterInput {
  width: 192px !important;
  margin-right: 16px;
  display: flex;
  align-items: center;
}

.filterBtn {
  width: 136px;
  height: 38px;
  background-color: #ecf1fb;
  color: #1673fd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 16px;
}

.releaseBtn {
  width: 140px;
  height: 38px;
  background-color: #000000;
  color: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 16px;
  margin-right: 30px;
  margin-left: 16px;
}

.listTitleBar {
  height: 40px;
  background-color: #f5f6f6;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  /* margin-top: 32px; */
}

.listTitleBarItem {
  text-indent: 16px;
  font-weight: 600;
}

.listContentBarItem {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: unset;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  max-height: 75px;
}

.listContentBarItem::-webkit-scrollbar {
  width: 3px;
}

.listContentBarItem::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 2px;
}

.listContentBarItem::-webkit-scrollbar-track {
  background: transparent;
}

.listTitleBarItemBorder {
  width: 1px;
  height: 80px;
  background-color: #e5e5e5;
  position: absolute;
  right: 0;
  top: calc(50% - 40px);
  display: none;
}

.listContentBar {
  height: 100px;
  background-color: #fff;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  position: relative;
  border-bottom: 2px solid #f1f1f1;
}

.imgContentItem {
  width: 60px;
  height: 60px;
  margin-left: 4px;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  font-size: 11px;
}

.imgContentItemImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.videoContentItem {
  width: 60px;
  height: 60px;
  margin-left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}

.videoContentItemImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.videoContentItemPlayIcon {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.linkContentItem {
  display: flex;
  align-items: center;
}

.linkContentItemIcon {
  width: 80px;
  height: 80px;
}

.linkContentItemR1 {
  margin-left: 12px;
  font-size: 14px;
}

.linkContentItemR2 {
  margin-left: 12px;
  font-size: 14px;
  color: #4a90e2;
}

.listContentUserIcon {
  width: 40px;
  height: 40px;
  border-radius: 40px;
  margin: auto;
}

.listContentBarActionItem {
  width: 56px;
  height: 32px;
  border-radius: 4px;
  background-color: #e2efff;
  color: #4a90e2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  margin: 4px;
}

.listContentBarActionItemDelete {
  background-color: #ffecec;
  color: #fb5d5c;
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.logoutBtn {
  width: 80px;
  height: 32px;
  background-color: #ffecec;
  color: #fb5d5c;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
}

.header-main-top {
  width: 38px;
  height: 38px;
  border-radius: 38px;
  display: block;
  margin: auto;
  margin-bottom: 10px;
}

.imgMore {
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.timeSendLabel {
  font-size: 22px;
  font-weight: 600;
  margin-right: 62px;
}

.pageBar {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 40px;
  margin-left: 16px;
}

.batchSelectAllBar {
  font-size: 14px;
  color: #3c3c3c;
}

.pageBarRight {
  display: flex;
  align-items: center;
}

.pageInput {
  width: 40px;
  height: 30px;
  border-radius: 4px;
  background-color: #f5f6fa;
  border: none;
  font-size: 14px;
  text-align: center;
  margin: 0 16px;
}

.pageBtn {
  width: 92px;
  height: 40px;
  background-color: #f5f6fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3c3c3c;
}

.topSucaiIcon {
  position: absolute;
  left: 0;
  top: 0;
  width: 34px;
  height: 16px;
  background-color: #f49a24;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 新增视频预览样式 */
.videoPreviewMask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 3000; /* 确保层级高于其他元素 */
  display: flex;
  justify-content: center;
  align-items: center;
}

.videoPreviewContent {
  position: relative;
  max-width: 80%;
  max-height: 80%;
  background: #000;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  display: flex;
}

.videoPlayer {
  max-width: 100%;
  max-height: 80vh;
  outline: none;
}

.videoCloseBtn {
  position: absolute;
  top: -40px;
  right: -40px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  color: #fff;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}

.videoCloseBtn:hover {
  background: rgba(255, 255, 255, 0.6);
}

/* 补充：让视频列表项鼠标变成手型 */
.videoContentItem {
  cursor: pointer;
}

.tooltipContent {
  width: 400px;
  word-break: break-all;
  white-space: pre-wrap;
  line-height: 30px;
  font-size: 15px;
}

.shadowTipSize {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: unset;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  width: 144px;
  height: 100%;
  overflow: scroll;
  position: absolute;
  top: 0px;
  right: 500px;
}

.topRBtnP {
  display: flex;
  align-items: center;
}

.oldBtn {
  /* position: absolute;
  right: 10px;
  top: 15px; */
  font-size: 30px;
  width: 80px;
  height: 32px;
  background-color: #ecf1fb;
  color: #1673fd;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
}

.cellCover {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9999;
}

/* .cellCover {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.cellCover ::before {
  width: 100%;
  height: 100%;
  background-color: #f5f6f6;
  filter: blur(5px);
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}
 */

/* 模拟页面背景 */
.background-container {
  width: 100%;
  height: 100%;
  /* background: url("https://picsum.photos/1200/800") no-repeat center
    center/cover; */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 核心代码 */
.glass-mask {
  width: 100%;
  height: 100%;
  color: #3c3c3c;

  /* 1. 设置背景颜色为半透明 (必须，否则看不到背后) */
  /* background: rgba(255, 255, 255, 0.2); */
  background-color: #fafafa;

  /* 2. 使用背景滤镜进行高斯模糊 */
  /* -webkit-backdrop-filter: blur(10px);  */
  /* backdrop-filter: blur(10px); */

  /* 装饰性样式 */
  /* box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3); */
}

.glass-mask-main {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 20px;
}

.glass-mask-main img {
  margin-right: 10px;
  width: 24px;
  height: 24px;
}

/* 备注编辑弹窗 */
.remarkEditCover {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remarkEditMain {
  width: 720px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 #e5e5e580;
  position: relative;
}

.remarkSelectorBar {
  width: calc(100% - 48px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.remarkSelectorNav {
  display: flex;
  align-items: center;
  gap: 12px;
}

.remarkSelectorArrow {
  font-size: 12px;
  color: #3c3c3c;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  user-select: none;
}

.remarkSelectorArrow:hover {
  background-color: #f5f6f6;
}

.remarkSelectorArrowDisabled {
  color: #ccc;
  cursor: not-allowed;
  pointer-events: none;
}

.remarkSelectorLabel {
  font-size: 14px;
  color: #3c3c3c;
}

.remarkEditMainT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 81px;
  padding: 0 24px;
  border-bottom: 1px solid #e5e5e5;
}

.remarkEditMainTL {
  font-size: 24px;
  line-height: 28px;
  color: #000000;
}

.remarkEditMainTR {
  width: 20px;
  height: 20px;
  display: block;
  cursor: pointer;
}

.remarkEditMainB {
  max-height: 500px;
  overflow: auto;
  padding: 24px;
}

.remarkFormItem {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 24px;
}

.remarkFormItemL {
  width: 104px;
  height: 40px;
  padding-left: 24px;
  color: #3c3c3c;
  font-size: 18px;
  font-weight: 500;
  flex-shrink: 0;
}

.remarkFormItemR {
  flex: 1;
}

.remarkTextarea {
  width: 100%;
  min-height: 120px;
  padding: 16px;
  box-sizing: border-box;
  color: #3c3c3c;
  background-color: #fafafa;
  border-radius: 8px;
  border: none;
  resize: vertical;
  font-size: 16px;
  font-family: inherit;
}

.remarkTextarea:focus {
  outline: 2px solid #4a90e2;
  background-color: #fff;
}

.remarkImageGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 12px;
}

.remarkImageItem {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
}

.remarkImagePreview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.remarkImageRemove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.remarkImageRemove:hover {
  background-color: #fb5d5c;
}

.remarkImageAdd {
  width: 100px;
  height: 100px;
  border-radius: 8px;
  border: 2px dashed #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #fafafa;
}

.remarkImageAdd:hover {
  border-color: #fb5d5c;
  background-color: #fff9f9;
}

.remarkImageAdd img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.remarkHiddenInput {
  display: none;
}

.remarkEditMainBottomBar {
  width: calc(100% - 48px);
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 16px 24px;
  border-top: 1px solid #e5e5e5;
}

.remarkCancelBtn {
  width: 88px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #3c3c3c;
  background-color: #f5f6f6;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  cursor: pointer;
}

.remarkCancelBtn:hover {
  background-color: #e5e5e5;
}

.remarkDeleteBtn {
  width: 88px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fb5d5c;
  background-color: #fff;
  border: 1px solid #fb5d5c;
  border-radius: 4px;
  cursor: pointer;
  margin-right: auto;
}

.remarkDeleteBtn:hover {
  background-color: #fef0f0;
}

.remarkSaveBtn {
  width: 88px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
  background-color: #fb5d5c;
  border-radius: 4px;
  cursor: pointer;
}

.remarkSaveBtn:hover {
  background-color: #e8504f;
}

.remarkListScroll::-webkit-scrollbar {
  width: 3px;
}

.remarkListScroll::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 2px;
}

.remarkListScroll::-webkit-scrollbar-track {
  background: transparent;
}

.remarkListScroll {
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 transparent;
}

.listContentBarActionItemRemark {
  background-color: #e2efff;
  color: #4a90e2;
}

/* 批量分类按钮 */
.batchBtn {
  width: 140px;
  height: 38px;
  background-color: #1673fd;
  color: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 16px;
  margin-left: 16px;
  cursor: pointer;
}

.batchBtn:hover {
  background-color: #4791ff;
}

/* 完成按钮禁用态 */
.batchCompleteDisabled {
  background-color: #ccc !important;
  cursor: not-allowed;
}

/* 退出批量按钮 */
.batchExitBtn {
  width: 140px;
  height: 38px;
  background-color: #f5f6f6;
  color: #3c3c3c;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 16px;
  margin-left: 16px;
  cursor: pointer;
}

.batchExitBtn:hover {
  background-color: #e5e5e5;
}

/* 批量分类弹窗 */
.batchClassifyCover {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.batchClassifyMain {
  width: 560px;
  max-height: 80vh;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 #e5e5e580;
  display: flex;
  flex-direction: column;
}

.batchClassifyMainT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 0 24px;
  border-bottom: 1px solid #e5e5e5;
  flex-shrink: 0;
}

.batchClassifyMainTL {
  font-size: 20px;
  font-weight: 600;
  color: #3c3c3c;
}

.batchClassifyMainTR {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.batchClassifyTips {
  font-size: 14px;
  color: #1673fd;
  margin-bottom: 8px;
}

.batchClassifyMainB {
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1;
}

.batchDialogSection {
  margin-bottom: 20px;
}

.batchDialogSectionT {
  font-size: 16px;
  color: #3c3c3c;
  font-weight: 500;
  margin-bottom: 12px;
}

.batchDialogSectionB {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.batchChip {
  height: 20px;
  border: 1px solid #e5e5e5;
  border-radius: 24px;
  padding: 8px 20px;
  background-color: #fff;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}

.batchChip:hover {
  border-color: #fb5d5c;
  color: #fb5d5c;
}

.batchChipSel {
  background: #ffecec;
  border: 1px solid #fb5d5c;
  border-radius: 24px;
  color: #fb5d5c;
}

.batchClassifyMainBottomBar {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e5e5e5;
  flex-shrink: 0;
}

.batchClassifyCancelBtn {
  width: 88px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #3c3c3c;
  background-color: #f5f6f6;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  cursor: pointer;
}

.batchClassifyCancelBtn:hover {
  background-color: #e5e5e5;
}

.batchClassifyConfirmBtn {
  width: 88px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
  background-color: #fb5d5c;
  border-radius: 4px;
  cursor: pointer;
}

.batchClassifyConfirmBtn:hover {
  background-color: #e8504f;
}

</style>
